import { render, staticRenderFns } from "./richText.edit.vue?vue&type=template&id=54f034e5"
import script from "./richText.edit.vue?vue&type=script&lang=js"
export * from "./richText.edit.vue?vue&type=script&lang=js"
import style0 from "./richText.edit.vue?vue&type=style&index=0&id=54f034e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports